import Tips from './tips'
import MdUtils from './mdUtils'
import {
  Dialog
} from 'vant';
import valid from './valid'
// 去除浮点运算问题
import './MathUtils'
import 
  Consts
 from './consts';

export {
  default as Tips
}
from './tips'
export {
  default as MdUtils
}
from './mdUtils'

export default {
  Tips,
  MdUtils,
  install(Vue) {
    Vue.prototype.$tips = Tips
    Vue.prototype.$mdUtils = MdUtils
    Vue.prototype.$dialog = Dialog
    Vue.prototype.$valid = valid
    Vue.prototype.$consts = Consts;
  }
}